/**
 * The class-link acceptor and the mission text helpers the React surfaces
 * (app/ui/WorkOrdersBoard, app/ui/OrderDebrief, app/shell/MissionChip)
 * share. All text resolves through tOr at render time, so the catalogues can
 * translate mission prose (mission.<id>.*) without this file knowing.
 */

import { tOr } from '../i18n/i18n'
import { MISSIONS, type Mission } from '../learn/missions'
import { missionState } from '../learn/missionState'
import { missionOnFloor } from '../learn/floor'

export const missionTitle = (m: Mission): string => tOr(`mission.${m.id}.Title`, m.title)
export const missionBriefing = (m: Mission): string => tOr(`mission.${m.id}.Briefing`, m.briefing)
export const missionDebriefText = (m: Mission): string => tOr(`mission.${m.id}.Debrief`, m.debrief)
export const missionObjectiveLabel = (m: Mission, i: number): string =>
  tOr(`mission.${m.id}.objective.${m.objectives[i].id}`, m.objectives[i].label)

/**
 * Accept the order a class link names, if the URL carries one. Called once at
 * startup; the parameter is then stripped so a student's own later reloads do
 * not silently restart the order and erase their progress.
 */
export function acceptFromUrl(): void {
  const id = new URLSearchParams(location.search).get('order')
  if (!id) return
  const mission = MISSIONS.find((m) => m.id === id)
  // A class link opened on a floor without the order's station: nothing is
  // armed, and the board says why when they look.
  if (mission && missionOnFloor(mission)) missionState.accept(mission)
  const url = new URL(location.href)
  url.searchParams.delete('order')
  history.replaceState(null, '', url)
}
